import { getSupabase, type TypedSupabaseClient } from '@infra/supabase/client';
import type { IFinanceGlobalRepository, FinanceGlobalParams, FinanceGlobalResumo } from '@modules/financeGlobal';

const requireSupabase = (): TypedSupabaseClient => {
  const client = getSupabase();
  if (!client) throw new Error('Supabase não inicializado.');
  return client;
};

export class SupabaseFinanceGlobalRepository implements IFinanceGlobalRepository {
  getResumo = async ({ ano, mes = null, enterpriseSlugs = null }: FinanceGlobalParams): Promise<FinanceGlobalResumo> => {
    const { data, error } = await requireSupabase().rpc('financeiro_global_resumo' as never, { p_ano: ano, p_mes: mes, p_enterprise_slugs: enterpriseSlugs ? [...enterpriseSlugs] : null } as never);
    if (error) throw error;
    const result = (data ?? {}) as unknown as FinanceGlobalResumo;
    if (result.success === false) throw new Error(result.error || 'Falha ao carregar o Financeiro Global.');
    return result;
  };
}
